// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"885e0ab4","132":"62b5f594","136":"1d5a90fa","240":"4a43f2ee","384":"dbe93cf4","408":"a6c9e74a","512":"e2fe6436","592":"65c92cae","604":"18db553f","808":"e9cef1c7","948":"f105cbfc"}[chunkId] + ".chunk.js";
};